module.exports = __webpack_public_path__ + "img/meta.63d36de5.svg";